/// <amd-module name="CodeCoverage/CodeCoverageTab/Components/CoveredBarChart" />
import * as React from 'react';
import { VssComponent } from 'VSS/Platform/Layout';


export interface ICoveredBarChartProps {
    width: number;
    coveredPercentage: number;
}

export class CoveredBarChart extends VssComponent<ICoveredBarChartProps, {}> {
    public render(): JSX.Element {
        const coveredWidth = this.props.coveredPercentage / 100 * this.props.width;

        return (
            <div className="bar-chart-container">
                <div className="covered-bar" style={{width: coveredWidth + "px"}} />
                <div className="not-covered-bar" style={{width: (this.props.width - coveredWidth) + "px"}} />
            </div>
        );
    } 
}
